import React, { FC } from 'react';
import { BiSmile as SatisfactionIcon } from '@react-icons/all-files/bi/BiSmile';
import { Avatar, Box, BoxProps } from '@material-ui/core';

type Props = BoxProps & {
  eventType: string;
};

const EventAvatar: FC<Props> = ({ eventType }) => {
  switch (eventType) {
    case 'deal_satisfaction':
    case 'ticket_satisfaction':
      return (
        <Box bgcolor='secondary.main' clone>
          <Avatar>
            <SatisfactionIcon />
          </Avatar>
        </Box>
      );
    default:
      return null;
  }
};

export default EventAvatar;
